import { useTranslation } from 'react-i18next'
import { usePageMeta } from './usePageMeta.js'

interface LocalePageMetaOptions {
  noindex?: boolean
  ogImage?: string
}

export function useLocalePageMeta(
  namespace: 'marketing',
  keyPrefix: string,
  canonical: string,
  options?: LocalePageMetaOptions
): void {
  const { t } = useTranslation(namespace)
  const title = t(`${keyPrefix}.title`)
  const description = t(`${keyPrefix}.description`)
  const keywords = t(`${keyPrefix}.keywords`, { defaultValue: '' })

  usePageMeta(title, description, canonical, {
    ogTitle: title,
    ogDesc: description,
    ogUrl: canonical,
    ...(keywords ? { keywords } : {}),
    ...(options?.noindex ? { noindex: true } : {}),
    ...(options?.ogImage ? { ogImage: options.ogImage } : {}),
  })
}
